import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/wifi/flagship/u6-enterprise.png";
import type { Product } from "../../types";
import { wifiFlagship } from "../product-list-groups/wifiFlagship";
import {
  connectedDevices,
  dimensions,
  radio6Ghz,
  uplink,
  wifiCoverage,
  wifiTechnology,
} from "../properties";

export const u6enterprise: Product = {
  id: "u6Enterprise",
  productTitle: "U6 Enterprise",
  techspecsPath: [SiteId.TechSpecs, "/unifi/wifi/u6-enterprise"],
  storePathParts: { productSlug: "u6-enterprise", category: "wifi-flagship" },
  sku: "U6-Enterprise",
  description: "u6Enterprise.description",
  image: { src: image, width: 200, height: 160 },
  productListGroup: wifiFlagship,
  propertyValues: [
    {
      propertyId: dimensions.id,
      value: {
        type: "translation",
        value: "u6Enterprise.dimensions",
      },
    },
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "u6Enterprise.wifiTechnology",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: wifiCoverage.id,
      value: { type: "string", value: "140 m² (1,500 ft²)" },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "600+" },
    },
    {
      propertyId: "powerMethodPoe",
      value: { type: "string", value: "PoE+" },
    },
    {
      propertyId: uplink.id,
      value: { type: "translation", value: "u6enterprise.uplink" },
    },
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "extendedRangeMode6Ghz",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "antennaType",
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "wifiMounting",
      value: {
        type: "translation",
        value: "commons.mounting.ceilingWall",
      },
    },
  ],
};
